import React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
// tslint:disable-next-line:no-unused-variable
import { Translate, ICrudGetAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './app.reducer';
import { IApp } from 'app/shared/model/app.model';
// tslint:disable-next-line:no-unused-variable
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IAppDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export class AppDetail extends React.Component<IAppDetailProps> {
  componentDidMount() {
    this.props.getEntity(this.props.match.params.id);
  }

  render() {
    const { appEntity } = this.props;
    return (
      <Row>
        <Col md="8">
          <h2>
            <Translate contentKey="dealorGatewayApp.app.detail.title">App</Translate> [<b>{appEntity.id}</b>]
          </h2>
          <dl className="jh-entity-details">
            <dt>
              <span id="app_secret">
                <Translate contentKey="dealorGatewayApp.app.app_secret">App Secret</Translate>
              </span>
            </dt>
            <dd>{appEntity.app_secret}</dd>
            <dt>
              <span id="packageName">
                <Translate contentKey="dealorGatewayApp.app.packageName">Package Name</Translate>
              </span>
            </dt>
            <dd>{appEntity.packageName}</dd>
            <dt>
              <Translate contentKey="dealorGatewayApp.app.tenant">Tenant</Translate>
            </dt>
            <dd>{appEntity.tenantId ? appEntity.tenantId : ''}</dd>
          </dl>
          <Button tag={Link} to="/entity/app" replace color="info">
            <FontAwesomeIcon icon="arrow-left" />{' '}
            <span className="d-none d-md-inline">
              <Translate contentKey="entity.action.back">Back</Translate>
            </span>
          </Button>
          &nbsp;
          <Button tag={Link} to={`/entity/app/${appEntity.id}/edit`} replace color="primary">
            <FontAwesomeIcon icon="pencil-alt" />{' '}
            <span className="d-none d-md-inline">
              <Translate contentKey="entity.action.edit">Edit</Translate>
            </span>
          </Button>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = ({ app }: IRootState) => ({
  appEntity: app.entity
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppDetail);
